import React from 'react';
import { useTranslation } from 'react-i18next';
import { Body } from '../../body';
import styled from '@emotion/styled';

const Container = styled.div`
	${({ theme }) => `
		display: flex;
		background-color: var(--cui-bg-subtle);
		padding: ${theme.spacings.giga};
		gap: ${theme.spacings.mega};
		border-radius: ${theme.borderRadius.kilo};
		margin-bottom: ${theme.spacings.mega};
	`}
`;

const StyledBody = styled(Body)`
	font-weight: 600;
`;

const SuBusinessAccount = () => {
	const { t } = useTranslation();

	return (
		<Container data-testid="su-business-account-note">
			<img src="/payout.svg" alt="SumUp Business Account" />
			<StyledBody size="s">
				{t('payment_method.su_business_account.note')}
			</StyledBody>
		</Container>
	);
};

export default SuBusinessAccount;
